import moment from 'moment-mini'

import { Injectable } from '@angular/core'

import { Gate } from './gate'

@Injectable()
export class GateSerializer {
  fromJson(json: any): Gate {
    return json
  }

  toJson(gate: Gate): any {
    return gate
  }
}
